import { observer } from 'mobx-react-lite';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import React, { useEffect } from 'react';
import configurationStore from 'common/stores/configuration/configuration.store';
import '../community-information.scss';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { SaveOutlined } from '@ant-design/icons';
import configurationService from 'common/services/configuration-service/configuration.service';
import { ITrafficLogArchiveConfigurationUpdate } from 'common/services/configuration-service/configuration.service.types';
import { notification } from 'common/utils/notification';

export const TrafficLogArchiveConfiguration = observer(() => {
  const [form] = Form.useForm();

  const initData = configurationStore.configuration?.trafficLogArchive;

  useEffect(() => {
    if (form) {
      form.setFieldsValue(initData);
    }
  }, [form, initData]);

  const onFinish = async (values: any) => {
    const request: ITrafficLogArchiveConfigurationUpdate = {
      updateTrafficLogArchive: {
        trafficLogDaysToArchive: values.trafficLogDaysToArchive,
      },
    };

    const result = await configurationService.updateSystemConfiguration(request);
    configurationStore.setConfiguration(result);
    notification.success({
      message: 'Configurations successfully updated',
      duration: 5,
    });
  };

  return (
    <FormWrapper form={form} onFinish={onFinish} initialValues={initData} layout="vertical" style={{ height: '100%' }}>
      <Card className="eiq-card eiq-card-border eiq-configuration" style={{ height: '100%' }}>
        <Row className="eiq-card-header">
          <Col span={24}>
            <h1 className="h1">Traffic Log Archive</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={12}>
            <Space className="full-width" style={{ flexDirection: 'column' }}>
              <Form.Item name="trafficLogDaysToArchive" label="Traffic log retention period in days">
                <Input type="number" min={1} max={365} />
              </Form.Item>
            </Space>
            <Button htmlType="submit" type="primary" icon={<SaveOutlined />} style={{ width: '100%' }}>
              Save
            </Button>
          </Col>
        </Row>
      </Card>
    </FormWrapper>
  );
});
